import React, { useState } from 'react'
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import TitleIcon from '@mui/icons-material/Title';
import Person3Icon from '@mui/icons-material/Person3';
import ReportIcon from '@mui/icons-material/Report';

import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import Y from '../../pages/ListDam.module.css'


import { Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { useGlobalContext } from '../Context';
import EditAdmin from '../editAdminModal';
import { useDispatch, useSelector } from 'react-redux';
import EditUserInfo from '../editUserInfo';
import { setUsers } from '../../redux/slices/adminSlice';
import apiService from '../../api/ApiService';
import EmptyReturn from '../EmptyReturn';
import { Switch } from '@mui/material';
import { MobileFriendly } from '@mui/icons-material';
const moment=require('moment-jalaali')

const UserList = ({Value}) => {
    const {currentUsers,currentTheme}=useSelector(state=>state.p.admin)
    const dispatch=useDispatch()
    const [iindex,setIindex]=useState()
    const {openModalls2,closeModalls2,isOpenModal2,}=useGlobalContext()
    const {openD,opens,isOpenModal,openModalls,openModallTime,isModalTimeOpen}=useGlobalContext();
    const [currentName,setCurrentName]=useState('')
    const toggleUser=async(id,index)=>{
      const res=await apiService.toggleUser(id);
      const editedList = [
        ...currentUsers[0].slice(0,index),
        res.data,
        ...currentUsers[0].slice(index+1)
      ];
      
      dispatch(setUsers([editedList,currentUsers[1]]))
     
    }

  return (
    <>
    {currentTheme&&<Container className='allCardsCon'>
    <Row style={{width:'100%'}}>
    {
       currentUsers[Value]?.length?currentUsers[Value].map((item,index)=>{
           const {createAt}=item;
                   const pbirth=moment(createAt).format('jYYYY-jMM-jDD HH:mm')
           return <div key={index} style={{display:'flex', flexWrap:'wrap',gap:'4px'}} className='  col-sm-12 col-md-6 col-lg-4 col-xl-3 col-xxl-3 gap-3'>
               <div  className='ThemeCard' >
           <div className='ThemeCardItem '>
           <div className='LogoFormT'><div><span>
                <DriveFileRenameOutlineIcon/>
                </span>
                    </div></div>
               <span>نام :</span>
               <span>{item?.username}</span>
           </div>
           
           <div className='ThemeCardItem'>
           <div className='LogoFormT'><div><span>
                <TitleIcon/>
                </span>
                    </div></div>
               <span>  موضوع :</span>
               <span>{item?.title}</span>
           </div>
           <div className='ThemeCardItem'>
           <div className='LogoFormT'><div><span>
                <Person3Icon/>
                </span>
                    </div></div>
               <span> نقش :</span>
               <span>{item?.role}</span>
           </div>
           <div className='ThemeCardItem'>
           <div className='LogoFormT'><div><span>
                <MobileFriendly/>
                </span>
                    </div></div>
               <span> شماره همراه :</span>
               <span>{item?.phoneNumber}</span>
           </div>
           <div className='ThemeCardItem'>
           <div className='LogoFormT'><div><span>
                <ReportIcon/>
                </span>
                    </div></div>
               <span>  فعال / غیر فعال :</span>
               <span >
                <Switch color="success" checked={item?.isActive} onChange={()=>toggleUser(item.id,index)} />

                    </span>
           </div>
           
           <div style={{display:'flex',gap:'5px',fontSize:'12px'}}>
               <div onClick={()=>{setIindex(index);openModalls2();setCurrentName(item)}} className="EditMOdalBtnForm">تغییر مشخصات</div>
               <div onClick={()=>{openModalls();setCurrentName(item)}} className="EditMOdalBtnForm">تغییر رمز عبور</div>
           </div>
           
         </div>
           </div>
       })
    :<EmptyReturn/>}
    </Row>
    {isOpenModal&&<EditAdmin namee={currentName}/>}
         {isOpenModal2&&<EditUserInfo iindex={iindex} data={currentName}/>}
   </Container>}
    </>
  )
}

export default UserList
